import React, { memo, forwardRef } from "react";
const SvgCapitalGamma = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M12 24.136a1 1 0 01-1-1V8a1 1 0 011-1h7.148a.948.948 0 110 1.896H13.66a.5.5 0 00-.5.5v13.74a1 1 0 01-1 1H12z"
      />
    </svg>
  );
});
SvgCapitalGamma.displayName = "SvgCapitalGamma";
const MemoForwardRef = memo(SvgCapitalGamma);
export default MemoForwardRef;
